import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CLUser } from './user';
import { CLUserService } from './user.service';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';

@Injectable()
export class CLUserResolver implements Resolve<CLUser> {

  constructor(
    private router: Router,
    private userService: CLUserService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): CLUser | Observable<CLUser> | Promise<CLUser> {
    return new Promise<CLUser>(async (resolve, reject) => {

      let user_id = lookupParam(route, 'client_user_id');

      this.notifier.startProgress();

      this.userService
        .user(user_id)
        .subscribe((user) => {
          
          if(user) {
            return resolve(user);
          }
          else {
            this.router.navigate(['shares-ledger', 'client-users']);
            return resolve(null);
          }
        });
    });
  }
}